'use client';

import { useRef } from 'react';
import type { CompanyFormData } from '@/shared/lib/validation/registration-wizard/company';
import type { FormHandle } from '@/shared/ui/forms/form-handle';
import { useSplitWizard } from '../model/split-wizard-context';


/** Шаг «компания»: проверяет форму, сохраняет данные в визарде и переходит дальше. */
export const useCompanyStep = () => {
    const { state, dispatch } = useSplitWizard();
    const companyRef          = useRef<FormHandle<CompanyFormData>>(null);

    const handleNext = async () => {
        const company = await companyRef.current?.submit();

        if (!company) return;

        dispatch({ type: 'commit', key: 'company', value: company });
        dispatch({ type: 'next' });
    };

    return { companyRef, handleNext, state };
};
